import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { useParams } from 'react-router-dom'
import { Column } from 'primereact/column'
import ConsumptionService from '../../../../services/alvic/consumption/consumption.service'
import MainCommonView from '../../../../components/common/MainCommonView'
import FilterDateRange from '../../../../components/common/filter-date-range/FilterDateRange'
import { SubTitle } from '../../../../components/common/form-components/label/Label'
import DataTableComp from '../../../../components/common/data-table/DataTableComp'
import { parseProduct } from '../../../../utils/helpers/common'
import './ownFuelStationConsumption.scss'

const OwnFuelStationConsumption = () => {
  const { formatMessage: msg } = useIntl()
  const { id } = useParams()

  const today = new Date()
  const [consumption, setConsumption] = useState({})
  const [prediction, setPrediction] = useState([])

  useEffect(() => {
    getByOwnStationConsumption()
    getByOwnStationPrediction()
  }, [])

  const getByOwnStationConsumption = async () => {
    const l = new Date()
    const initDate = new Date(l.setDate(l.getDate() - 7))
    const finishDate = new Date()

    const resp = await ConsumptionService.getByOwnStationConsumption({
      id,
      initDate,
      finishDate,
    })
    if (resp) {
      setConsumption(resp)
    }
  }

  const getByOwnStationPrediction = async () => {
    const l = new Date()
    const initDate = new Date()
    const finishDate = new Date(l.setDate(l.getDate() + 7))
    const resp = await ConsumptionService.getByOwnStationPrediction({
      id,
      initDate,
      finishDate,
    })
    if (resp) {
      setPrediction(resp)
    }
  }

  const handlerOnClickConsumptionFilter = async (initDate, finishDate) => {
    const resp = await ConsumptionService.getByOwnStationConsumption({
      id,
      initDate,
      finishDate,
    })
    if (resp) {
      setConsumption(resp)
    }
  }

  const handlerOnClickPredictionFilter = async (initDate, finishDate) => {
    const resp = await ConsumptionService.getByOwnStationPrediction({
      id,
      initDate,
      finishDate,
    })
    if (resp) {
      setPrediction(resp)
    }
  }

  const getConsumptionInitDateRange = () => {
    const minDate = new Date()
    minDate.setDate(today.getDate() - 7)
    const maxDate = new Date()
    return { minDate, maxDate }
  }

  const getPredictionInitDateRange = () => {
    const minDate = new Date()
    const maxDate = new Date()
    maxDate.setDate(today.getDate() + 7)
    return { minDate, maxDate }
  }

  const headerOptions = {
    title: msg({ id: 'consumption.prediction' }),
    handlerHeaderActions: {
      showBackButton: true,
    },
  }

  const dataTable = (value) => (
    <DataTableComp
      tableOptions={{
        value,
        dataKey: '_id',
      }}
      columns={[
        <Column
          field="product"
          header={msg({ id: 'product' })}
          body={(rowData) => parseProduct(rowData?.product)}
        />,

        <Column field="consumption" header={msg({ id: 'consumption' })} />,
      ]}
    />
  )

  const data = (
    <div className="consumption-prevention ">
      <div className="consumption boxContainer">
        <SubTitle id="consumption" />
        <div className="date-range-consumption">
          <FilterDateRange
            {...getConsumptionInitDateRange()}
            onClick={handlerOnClickConsumptionFilter}
          />
        </div>
        {dataTable(consumption?.consumptions)}
      </div>
      <div className="prevention boxContainer">
        <SubTitle id="prediction" />
        <div className="date-range-prevention">
          <FilterDateRange
            {...getPredictionInitDateRange()}
            onClick={handlerOnClickPredictionFilter}
          />
        </div>
        {dataTable(prediction?.consumptions)}
      </div>
    </div>
  )

  return <MainCommonView headerOptions={headerOptions} componentData={data} />
}

export default OwnFuelStationConsumption
